import React from 'react'
import { HelpTooltip } from 'components/Tooltip/HelpTooltip'

interface MetricCardProps {
  /** Icon element displayed in the leading square. */
  icon: React.ReactNode
  /** Formatted metric value (e.g., "1,234" or "65.5%"). */
  value: string
  /** Short label describing the metric. */
  label: string
  /** Detailed description shown in the tooltip popup; omit to hide the help icon. */
  tooltipContent?: string
}

/**
 * DS2026 compact metric card. Icon square (light brand tint) on the left,
 * label + optional help tooltip on top, large bold value below. Used on the
 * Performance Dashboard and any page-header stat tiles.
 */
export const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  value,
  label,
  tooltipContent,
}) => (
  <div className="flex items-center gap-3 bg-surface rounded-lg border border-line p-3.5">
    <div className="size-9 rounded-lg bg-brand-active/10 flex items-center justify-center shrink-0 text-brand-active">
      {icon}
    </div>
    <div>
      <div className="flex items-center gap-1 whitespace-nowrap text-sm text-fg-secondary">
        {label}
        {tooltipContent && (
          <HelpTooltip content={tooltipContent} placement="top" />
        )}
      </div>
      <div className="text-lg font-bold text-fg leading-tight tabular-nums">
        {value}
      </div>
    </div>
  </div>
)
